import {baseUrl} from '../common/config.js';
import {apiService} from '../common/apiCallService';
import moment from 'moment';
import queryString from 'query-string';
import { DispatcherFunction } from 'mygame-components';
import axios from "axios";
import { getWhiteLabelUIData, saveActivity } from '../common/commonService.js'
const browser = require('browser-detect');
const result = browser();
var UAParser= require('ua-parser-js');
const AuthenticateUser = {
    activityTrack:{ userid: '',
                    session_id:'',
                    hit_page:'',
                    hit_type:'',
                    deviceInfo:{
                      device_type:result.mobile ? 'Mobile' : 'Desktop',
                      browser_type:result.name,
                      browser_version:result.version,
                      language:navigator.language,
                      ip:'',
                    },
                    hit_attribute1:'',
                    hit_attribute2:'',
                    hit_attribute3:'',
                    hit_attribute4:'',
                    hit_attribute5:'',
                    hit_timestamp:moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ')
                  },
    isAuthenticated: false,
    location:'/',
    geoInfo(){
      return new Promise((resolve, reject) => {
        axios.get('https://api.ipify.org?format=json')
        .then((response) => {
            this.activityTrack.deviceInfo.ip = response.data.ip
            this.activityTrack.deviceInfo.country = ''
            localStorage.setItem("deviceInfo",JSON.stringify(this.activityTrack.deviceInfo))
            resolve()
        })
        .catch((error) => {
            this.activityTrack.deviceInfo.ip = null
            this.activityTrack.deviceInfo.country = ''
            localStorage.setItem("deviceInfo",JSON.stringify(this.activityTrack.deviceInfo))
            resolve()
        });
      })
    },
    authenticate(formData) {
      localStorage.setItem("activityTrack", [])
      return new Promise((resolve, reject) =>{
        this.activityTrack.userid = formData.username
        this.activityTrack.hit_timestamp = moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ')
        var parser = new UAParser(),
        result = parser.getResult()
        saveActivity({
          hit_page: 'LoginWithClient',
          hit_type: 'userLogin_API_Call',
        })

        apiService(baseUrl + '/appUser/userLogin', {
          "username": formData.username,
          "password": formData.password,
          "activityTrack":AuthenticateUser.activityTrack,
          ...result
        }, async (data) => {
          if(data.accountId  != '')
            localStorage.setItem("accountId", data.accountId)
          localStorage.setItem("username", data.username)
          localStorage.setItem("alias", data.alias)
          localStorage.setItem("token", data.token)
          localStorage.setItem("first_name", data.first_name ? data.first_name.replace(/(\w)(\w*)/g,
          function(g0,g1,g2){return g1.toUpperCase() + g2.toLowerCase();}):data.first_name)
          localStorage.setItem("last_name", data.last_name)
          localStorage.setItem("mygame_onboarded", data.mygame_onboarded)
          data.accountName && localStorage.setItem("accountName", data.accountName)
          localStorage.setItem("userRole", JSON.stringify(data.user_role))
          localStorage.setItem("loggedInType", data.userType)
          var path =localStorage.getItem("pathName")? localStorage.getItem("pathName").split('/'):[]
          console.log('pathName user login'+localStorage.getItem("pathName")+'   '+path);
          if(path.includes('ReportCard') && path[2] !== localStorage.getItem("accountName"))
          {
            localStorage.setItem("pathName", '/')
          }
          await getWhiteLabelUIData(localStorage.getItem("loggedInType")!== "Brand" ? localStorage.getItem("loggedInType") : JSON.parse(localStorage.getItem("brandLogin")).brand)
          this.isAuthenticated =  true
          saveActivity({
            hit_page: 'LoginWithClient',
            hit_type: 'LoginSuccess_Authenticate_Sucess',
            hit_attribute2:"Authenticate_Sucess_Block",
          })
          resolve(data)
        }, (data) => {
          saveActivity({
            hit_page: 'LoginWithClient',
            hit_type: 'LoginSuccess_Authenticate_Fail',
            hit_attribute2:"Authenticate_Error_Block",
          })
          this.isAuthenticated =  false
          resolve(data)
        })
      })
    },
    validateUser() {
      return new Promise((resolve, reject) =>{
        apiService(baseUrl + '/appUser/validateUser', {}, (data) => {
          // console.log('data,.........',data)
          AuthenticateUser.isAuthenticated = true
          localStorage.setItem("mygame_onboarded", data.mygame_onboarded)
          resolve(data)
        }, (data) => {
          let track = {}
            , pathName = ''
            , activityTrack = []
            , sessionTimeOutusername = ''
          // if (localStorage.getItem('activityTrack'))
          //   activityTrack = JSON.parse(localStorage.getItem('activityTrack'))
          track.hit_timestamp = moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
            track.session_id = localStorage.getItem("token")
          track.userid = localStorage.getItem("username")
          track.deviceInfo = JSON.parse(localStorage.getItem("deviceInfo"))
          track.hit_page = 'Logout'
          track.hit_type = 'Logout'
          track.hit_attribute1 = 'success'
          
          if (JSON.parse(localStorage.getItem('userRole')).indexOf('PLAYER') !== -1) {
            track.hit_attribute2 = localStorage.getItem("first_name")
            track.hit_attribute3 = localStorage.getItem("last_name")
            track.hit_attribute4 = localStorage.getItem("alias")
            // track.hit_player = localStorage.getItem("accountName")
          } else {
            track.hit_attribute2 = ''
            track.hit_attribute3 = ''
            track.hit_attribute4 = ''
          }
          track.hit_attribute5 = ''
          // activityTrack.push(track)
          // localStorage.setItem('activityTrack', JSON.stringify(activityTrack))
          // if (localStorage.getItem('token') && localStorage.getItem('activityTrack')) {
            // let activityTrack = JSON.parse(localStorage.getItem('activityTrack'))
            // localStorage.removeItem('activityTrack');
            saveActivity(track)
          // }
            if(localStorage.getItem('pathName')){
              pathName = localStorage.getItem('pathName')
              sessionTimeOutusername = localStorage.getItem('username')
            }
            localStorage.clear();
            if(pathName != '' && sessionTimeOutusername !=''){
              localStorage.setItem('pathName',pathName)
              localStorage.setItem('sessionTimeOutusername',sessionTimeOutusername)
            }

            AuthenticateUser.isAuthenticated = false
            resolve(data)

        })
      })
    },
    validateClientPlayerToken(dataObj) {
      try {
        localStorage.setItem("activityTrack", [])
        var parser = new UAParser(),
          result = parser.getResult()
        return new Promise((resolve, reject) => {
          let track={},
           activityTrack=[]
          //TODO: accountId & replayerId will not be available during Brand Login Case.
          track.userid = dataObj.accountId ? dataObj.accountId : dataObj.replayerId
          track.redirectUri = dataObj.redirectUri && dataObj.redirectUri === 'liveview' && "/liveview"
          track.hit_timestamp = moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ')
          track.session_id = localStorage.getItem("token")
          track.userid = dataObj.accountId ? dataObj.accountId : dataObj.replayerId
          track.deviceInfo = JSON.parse(localStorage.getItem("deviceInfo"))
          track.hit_page = 'LoginWithClient'
          track.hit_type = 'validateClientPlayerToken_API_Call'
          track.hit_attribute1 = ''
          track.hit_attribute2 = JSON.stringify(dataObj)
          track.hit_attribute3 = ''
          track.hit_attribute4 = ''
          track.hit_attribute5 = ''
          track.hit_player = dataObj.accountId

          activityTrack.push(track)
          const brandLogin = localStorage.getItem('brandLogin') 
          && localStorage.getItem('brandLogin').length>0 ? JSON.parse(localStorage.getItem('brandLogin')) : {};
          if(!dataObj.brand &&brandLogin.brand) {
              dataObj['brand'] = brandLogin.brand;
          }
          if(!dataObj.locale && brandLogin.locale) {
            dataObj['locale'] = brandLogin.locale;
        }
          // apiService(baseUrl + '/activitytracking', {activityTrack
          // }, (data) => {
          //   // console.log(data);
          // }, (err) => {
          //   localStorage.setItem('activityTrack',JSON.stringify(activityTrack))
          //   console.log(err);
          // })
  
          apiService(baseUrl + '/appUser/valiadateClientToken', {
            // "partnerToken": data.partnerToken,
            // "accountId": data.accountId,
            ...dataObj,...result,
            "activityTrack":AuthenticateUser.activityTrack
          }, async (data) => {
            track={}
            activityTrack=[]
            track.userid = dataObj.accountId ? dataObj.accountId : dataObj.replayerId
            track.redirectUri = dataObj.redirectUri && dataObj.redirectUri === 'liveview' && "/liveview"
            track.hit_timestamp = moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ')
            track.session_id = localStorage.getItem("token")
            track.userid = dataObj.accountId ? dataObj.accountId : dataObj.replayerId
            track.deviceInfo = JSON.parse(localStorage.getItem("deviceInfo"))
            track.hit_page = 'LoginWithClient'
            track.hit_type = 'LoginSuccess_validateClientPlayerToken_Response_Received'

            track.hit_attribute1 = ''
            track.hit_attribute2 = JSON.stringify(dataObj)
            track.hit_attribute3 = JSON.stringify(data)
            track.hit_attribute5=dataObj && dataObj.redirectUri && dataObj.redirectUri.includes("liveview") ?  "RedirectURI:/liveview" : 'RedirectURI:null',
            track.hit_player= data && data.accountName ? data.accountName : `No accountName :: ${dataObj.accountId}`
            
            saveActivity(track)
       
            console.log('valiadateClientToken data:', data)
            // console.log("data..............",data)
            if(data && data.success){
             console.log('data.success')
              if(data.accountId  != '')
                localStorage.setItem("accountId", data.accountId)
              localStorage.setItem("username", data.username)
              localStorage.setItem("alias", data.alias)
              localStorage.setItem("token", data.token)
              localStorage.setItem("first_name", data.first_name ? data.first_name.replace(/(\w)(\w*)/g,
              function(g0,g1,g2){return g1.toUpperCase() + g2.toLowerCase();}):data.first_name)
              localStorage.setItem("last_name", data.last_name)
              localStorage.setItem("mygame_onboarded", data.mygame_onboarded)
              data.accountName && localStorage.setItem("accountName", data.accountName)
              localStorage.setItem("userRole", JSON.stringify(data.user_role))
              //localStorage.setItem("loggedInType", dataObj.assertionId ? "Danskespil" : "PartyPoker")
              localStorage.setItem("loggedInType", dataObj.brandID === "DANSKESPIL" ? "Danskespil" : data.userType)
              var path =localStorage.getItem("pathName")? localStorage.getItem("pathName").split('/'):[]
              console.log('pathName validate ClientToken'+localStorage.getItem("pathName")+'   '+path);
              if(path.includes('ReportCard') && path[2] !== localStorage.getItem("accountName"))
              {
                localStorage.setItem("pathName", '/')
              }
              await getWhiteLabelUIData(localStorage.getItem("loggedInType")!== "Brand" ? localStorage.getItem("loggedInType") : JSON.parse(localStorage.getItem("brandLogin")).brand)
              this.isAuthenticated = true
              track = {}
              activityTrack = []
              track.userid = dataObj.accountId ? dataObj.accountId : dataObj.replayerId
              track.redirectUri = dataObj.redirectUri && dataObj.redirectUri === 'liveview' && "/liveview"
              track.hit_timestamp = moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ')
              track.session_id = localStorage.getItem("token")
              track.userid = dataObj.accountId ? dataObj.accountId : dataObj.replayerId
              track.deviceInfo = JSON.parse(localStorage.getItem("deviceInfo"))
              track.hit_page = 'LoginWithClient'
              track.hit_type = 'LoginSuccess_validateClientPlayerToken_Response_Received_ApiTrack'
              track.hit_attribute1 = localStorage.getItem("first_name")
              track.hit_attribute2 = localStorage.getItem("last_name")
              track.hit_attribute3 = localStorage.getItem("username")
              track.hit_attribute5 = dataObj && dataObj.redirectUri && dataObj.redirectUri.includes("liveview") ? "RedirectURI:/liveview" : 'RedirectURI:null',

              saveActivity(track)
              
              const { partnerToken = null } = queryString.parse(window.location.search)

              console.log("DispatcherFunction:", partnerToken)
              if(window.messageToNative || (window.external && window.external.NativeDispatch )){
                DispatcherFunction(`app:menu=3816&name=MYGAME_LOGIN_SUCCESS`,{
                  "partnerToken":partnerToken
                })
                localStorage.setItem("fromClient","true");
              }

              saveActivity({
                hit_page: 'LoginWithClient',
                hit_type: 'LoginSuccess_validateClientPlayerToken_Sucess',
                hit_attribute2: "succes_reponse",
                hit_attribute5:dataObj.redirectUri && dataObj.redirectUri.includes("liveview") ?  "RedirectURI:/liveview" : 'RedirectURI:null',
              })
              var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
              link.type = 'image/x-icon';
              link.rel = 'shortcut icon';
              link.href = dataObj.assertionId ? '../../favicon_Danskespil.ico' : '../../favicon_'+localStorage.getItem("loggedInType")+'.ico';
              document.getElementsByTagName('head')[0].appendChild(link);
            } else {
              console.log('else of data');
              const { partnerToken = null } = queryString.parse(window.location.search)
              if(window.messageToNative || (window.external && window.external.NativeDispatch)){
                  DispatcherFunction(`app:menu=3815&name=MYGAME_LOGIN_FAILED`,{
                    "partnerToken":partnerToken
              })}
              saveActivity({
                hit_page: 'LoginWithClient',
                hit_type: 'LoginSuccess_validateClientPlayerToken_Fail',
                hit_attribute2: "fail_reponse",
                hit_attribute5:dataObj.redirectUri && dataObj.redirectUri.includes("liveview") ?  "RedirectURI:/liveview" : 'RedirectURI:null',
              })
            }
            // update favicon.ico
            var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = '../../favicon.ico';
            //link.href = '../../favicon.ico';
            if (typeof localStorage != "undefined"){
               console.log(`localStorage.getItem("loggedInType")`,localStorage.getItem("loggedInType"))
              link.href = localStorage.getItem("loggedInType")=== "Danskespil"? '../../favicon_Danskespil.ico' :  '../../favicon_'+localStorage.getItem("loggedInType")+'.ico';
            }
             console.log("link.href--",link.href)
            document.getElementsByTagName('head')[0].appendChild(link);
            resolve(data)
          }, (err) => {
            console.log("DispatcherFunction failure", err);
            const { partnerToken = null } = queryString.parse(window.location.search)
            if(window.messageToNative || (window.external && window.external.NativeDispatch )){
                DispatcherFunction(`app:menu=3815&name=MYGAME_LOGIN_FAILED`,{
                  "partnerToken":partnerToken
              })}
            saveActivity({
              hit_page: 'LoginWithClient',
              hit_type: 'LoginSuccess_validateClientPlayerToken_Fail',
              hit_attribute2: "validateClientPlayerToken_error_Block",
              hit_attribute5:dataObj.redirectUri && dataObj.redirectUri.includes("liveview") ?  "RedirectURI:/liveview" : 'RedirectURI:null',
            })
            this.isAuthenticated =  false
            resolve(err)
          })
        })
      } catch(err) {
        console.log("catch block")
        const { partnerToken = null } = queryString.parse(window.location.search)
        if(window.messageToNative || (window.external && window.external.NativeDispatch )){
                  DispatcherFunction(`app:menu=3815&name=MYGAME_LOGIN_FAILED`,{
                    "partnerToken":partnerToken
              })}
        saveActivity({
          hit_page: 'LoginWithClient',
          hit_type: 'LoginSuccess_validateClientPlayerToken_Fail',
          hit_attribute2: "function_expection",
          hit_attribute5:dataObj.redirectUri && dataObj.redirectUri.includes("liveview") ?  "RedirectURI:/liveview" : 'RedirectURI:null',
        })
      }
    },




}

export default AuthenticateUser;


/** WEBPACK FOOTER **
 ** ./src/components/AuthenticateUser.js
 **/